<template>
  <div class="grid gap-2" :class="gridColumns">
    <div v-for="stats in boxes" class="bg-white overflow-hidden border shadow rounded-lg">
      <div class="p-3 sm:p-4" :title="stats.title">
        <div class="flex items-center">
          <div class="flex-shrink-0 rounded-md p-2" :class="stats.bgColor ? stats.bgColor : 'bg-blue-500'">
            <component :is="stats.icon" class="w-8 h-8"
                       :class="stats.iconColor ? stats.icon.Color : 'text-white'"></component>
          </div>
          <div class="ml-3 sm:ml-4 w-0 flex-1">
            <dl>
              <dt class="text-sm leading-5 font-medium text-gray-600 truncate">
                {{ stats.label }}
              </dt>
              <dd class="flex items-baseline flex-wrap">
                <div class="text-2xl leading-8 font-semibold text-gray-900 whitespace-nowrap truncate">
                  {{ stats.value }}
                </div>
                <div v-if="stats.up" class="ml-2 flex items-baseline text-sm leading-5 font-semibold text-green-600">
                  <svg class="self-center flex-shrink-0 h-5 w-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                          d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                          clip-rule="evenodd"/>
                  </svg>
                  <span class="sr-only">
                    Increased by
                  </span>
                  {{ stats.up }}
                </div>
                <div v-else-if="stats.down" class="ml-2 flex items-baseline text-sm leading-5 font-semibold text-red-600">
                  <svg class="self-center flex-shrink-0 h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                          d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
                          clip-rule="evenodd" />
                  </svg>
                  <span class="sr-only">
                    Decreased by
                  </span>
                  {{stats.down }}
                </div>
                <div v-else-if="stats.equal" class="ml-2 flex items-baseline text-sm leading-5 font-semibold text-blue-600">
                  <svg class="self-center flex-shrink-0 h-5 w-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                          d="M 14.715 11.5 L 5.285 11.5 C 4.852 11.5 4.5 11.948 4.5 12.5 L 4.5 13.5 C 4.5 14.052 4.852 14.5 5.285 14.5 L 14.715 14.5 C 15.148 14.5 15.5 14.052 15.5 13.5 L 15.5 12.5 C 15.5 11.948 15.148 11.5 14.715 11.5 Z M 14.715 5.5 L 5.285 5.5 C 4.852 5.5 4.5 5.948 4.5 6.5 L 4.5 7.5 C 4.5 8.052 4.852 8.5 5.285 8.5 L 14.715 8.5 C 15.148 8.5 15.5 8.052 15.5 7.5 L 15.5 6.5 C 15.5 5.948 15.148 5.5 14.715 5.5 Z"
                          clip-rule="evenodd"></path>
                  </svg>
                  <span class="sr-only">
                    Remains
                  </span>
                  {{stats.equal }}
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: "stat-boxes",
    props: {
        boxes: {type:Array, required: true},
        gridColumns: {type:String,default:"grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"},
    }
}
</script>